import { useContext } from "react"
import { AppContext } from "./context"

const EditorImportExport = () => {

    const {
        offCanvas,
        setSideBarTitle,
        setPopupSidebarType,
    } = useContext(AppContext)

    const openSidepanel = () => {
        setSideBarTitle("Import/Export")
        setPopupSidebarType("exp_imp")
        offCanvas.show()
    }

    return (
        <div className="d-flex justify-content-center gap-1 button3 px-3 py-1" style={{ cursor: "pointer" }} onClick={openSidepanel}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="#650260" className="bi bi-file-earmark-diff align-self-center" viewBox="0 0 16 16">
                <path d="M8 5a.5.5 0 0 1 .5.5V7H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V8H6a.5.5 0 0 1 0-1h1.5V5.5A.5.5 0 0 1 8 5m-2.5 6.5A.5.5 0 0 1 6 11h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5" />
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
            </svg>
            <p className="poppins mb-0 align-self-center">Export/Import</p>
        </div>
    )
}

export default EditorImportExport